import { ContainerIterator } from "../../ContainerBase";
import { throwIteratorAccessError } from "../../../utils/throwError";
export class RandomIterator extends ContainerIterator {
    /**
     * @internal
     */
    constructor(index, iteratorType) {
        super(iteratorType);
        this._node = index;
        if (this.iteratorType === 0 /* IteratorType.NORMAL */) {
            this.pre = function () {
                if (this._node === 0) {
                    throwIteratorAccessError();
                }
                this._node -= 1;
                return this;
            };
            this.next = function () {
                if (this._node === this.container.size()) {
                    throwIteratorAccessError();
                }
                this._node += 1;
                return this;
            };
        }
        else {
            this.pre = function () {
                if (this._node === this.container.size() - 1) {
                    throwIteratorAccessError();
                }
                this._node += 1;
                return this;
            };
            this.next = function () {
                if (this._node === -1) {
                    throwIteratorAccessError();
                }
                this._node -= 1;
                return this;
            };
        }
    }
    get pointer() {
        return this.container.getElementByPos(this._node);
    }
    set pointer(newValue) {
        this.container.setElementByPos(this._node, newValue);
    }
    isAccessible() {
        return this._node !== this.container.size();
    }
}
